import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import { ReplaceProposalInput, ReplaceProposalMutation } from '@/gql/graphql';

const REPLACE_PROPOSAL_MUTATION = graphql(`
  mutation ReplaceProposal($input: ReplaceProposalInput!) {
    replaceProposal(input: $input) {
      publicId
    }
  }
`);

const useReplaceProposal = (args?: {
  proposalId?: string;
  projectId?: string;
  options?: UseMutationOptions<
    ReplaceProposalMutation,
    unknown,
    ReplaceProposalInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: ReplaceProposalInput) => {
      return gqlClient.request(REPLACE_PROPOSAL_MUTATION, { input });
    },
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.project(args.projectId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useReplaceProposal;
